export default __webpack_public_path__ + "static/media/85.91e80ee4.png";